import { Component, OnInit } from '@angular/core';
import { Asset } from 'src/app/interfaces/asset';
import { ProductsService } from 'src/app/services/productsService/products.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-rental-history-list',
  templateUrl: './rental-history-list.component.html',
  styleUrls: ['./rental-history-list.component.less']
})
export class RentalHistoryListComponent implements OnInit {
  payments: Asset[] = new Array();
  displayedColumns = ['position', 'title', 'profile', 'price', 'method', 'date'];
  env = environment;
  private isLoading = false;
  private offset = 0;
  private count = 20;
  constructor(private productsService: ProductsService) { }

  ngOnInit(): void {
    this.payments = new Array();
    this.isLoading = false;
    this.offset = 0;
    this.getHistory();
  }

  // Get payments viewing history
  getHistory() {
    if (this.isLoading) {
      return;
    }
    let req = {
      offset: this.offset,
      count: this.count
    };
    this.isLoading = true;
    this.productsService.getRentals(req).then((resp: any) => {
      this.payments = this.payments && this.payments.length ? this.payments.concat(resp.data.payments) : resp.data.payments;
      this.isLoading = !resp.data.nextPage;
      this.offset += this.count
    });
  }

  // On Scroll down
  onScroll() {
    this.getHistory();
  }
}